import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-solicitud-transferencias',
  templateUrl: './solicitud-transferencias.component.html',
  styleUrls: ['./solicitud-transferencias.component.scss']
})
export class SolicitudTransferenciasComponent implements OnInit {

  fechaInicio = moment().locale('es').format('LL');

  pago = 0;
  letra: any;

  constructor() { }

  ngOnInit() {
    // this.fechaInicio = moment().locale('es').format('LL');
    // console.log( this.fechaInicio );
  }

  unidades (pago) {

    switch (pago) {
      case 1: {
        this.letra = 'un';
        break;
      }
      case 2: {
        this.letra = 'dos';
        break;
      }
      case 3: {
        this.letra = 'tres';
        break;
      }
      case 4: {
        this.letra = 'cuatro';
        break;
      }
      case 5: {
        this.letra = 'cinco';
        break;
      }
      case 6: {
        this.letra = 'seis';
        break;
      }
      case 7: {
        this.letra = 'siete';
        break;
      }
      case 8: {
        this.letra = 'ocho';
        break;
      }
      case 9: {
        this.letra = 'nueve';
        break;
      }
    }

    return this.letra;

  }

  numeroALetra(pago) {

    const decena = Math.floor(pago / 10);
    const unidad = pago - (decena * 10);
    
    switch (decena) {
      case 1: {
        switch (unidad) {
          case 0: {
            this.letra = 'diez';
            break;
          }
          case 1: {
            this.letra = 'once';
            break;
          }
          case 2: {
            this.letra = 'doce';
            break;
          }
          case 3: {
            this.letra = 'trece';
            break;
          }
          case 4: {
            this.letra = 'catorce';
            break;
          }
          case 5: {
            this.letra = 'quince';
            break;
          }
          default: this.letra = 'dieci' + this.unidades(unidad);
        } 
      }
      break;
      case 2: {
        switch (unidad) {
          case 0: {
            this.letra = 'veinte';
            break;
          }
          default: this.letra = 'veinti' + this.unidades(unidad);
        }
        break;
      }
      case 3: {
        this.letra = this.decenasY('treinta', unidad);
        break;
      }
      case 4: {
        this.letra = this.decenasY('cuarenta', unidad);
        break;
      }
      case 5: {
        this.letra = this.decenasY('cincuenta', unidad);
        break;
      }
      case 6: {
        this.letra = this.decenasY('sesenta', unidad);
        break;
      }
      case 7: {
        this.letra = this.decenasY('setenta', unidad);
        break;
      }
      case 8: {
        this.letra = this.decenasY('ochenta', unidad);
        break;
      }
      case 9: {
        this.letra = this.decenasY('noventa', unidad);
        break;
      }
      case 0: {
        this.letra = this.unidades(unidad);
      }
    }

    return this.letra;

  }

  decenasY(strSin, numUnidades) {
    if (numUnidades > 0) {
      return strSin + ' y ' + this.unidades(numUnidades);
    }
    return strSin;
  }

  centenas(pago) {
    // console.log( pago );
    const centenas = Math.floor(pago / 100);
    const decenas = pago - (centenas * 100);

    switch (centenas) {
      case 1: {
        if (decenas > 0) {
          this.letra = 'ciento ' + this.numeroALetra(decenas);
        } else {
          this.letra = 'cien';
        }
        break;
      }
      case 2: {
        this.letra = '';
        this.letra = 'doscietos ' + this.numeroALetra(decenas);
        break;
      }
      case 3: {
        this.letra = '';
        this.letra = 'trescientos ' + this.numeroALetra(decenas);
        break;
      }
      case 4: {
        this.letra = '';
        this.letra = 'cuatrocientos ' + this.numeroALetra(decenas);
        break;
      }
      case 5: {
        this.letra = '';
        this.letra = 'quinientos ' + this.numeroALetra(decenas);
        break;
      }
      case 6: {
        this.letra = '';
        this.letra = 'seiscientos ' + this.numeroALetra(decenas);
        break;
      }
      case 7: {
        this.letra = '';
        this.letra = 'setecientos ' + this.numeroALetra(decenas);
        break;
      }
      case 8: {
        this.letra = '';
        this.letra = 'ochocientos ' + this.numeroALetra(decenas);
        break;
      }
      case 9: {
        this.letra = '';
        this.letra = 'novecientos ' + this.numeroALetra(decenas);
        break;
      } 
    }

    return this.letra;

    // return this.numeroALetra(decenas);
    // console.log( this.letra );
  } // Centenas()

  seccion(num, divisor, strSingular, strPlural) {
    console.log( 'num: ' + num );
    console.log( 'divisor: ' + divisor );
    let cientos = Math.floor(num / divisor);
    let resto = num - (cientos * divisor);
    console.log( 'cientos: ' + cientos );
    console.log( 'resto: ' + resto );

    // let letras = '';
    this.letra = '';

    if (cientos > 0) {
      if (cientos > 1) {
        // letras = this.centenas(cientos) + ' ' + strPlural;
        this.letra = this.unidades(cientos) + ' ' + strPlural + ' ' + this.centenas(resto);
        console.log( this.letra );
      } else {
        this.letra = strSingular + ' ' + this.centenas(resto);
        console.log( this.letra );
      }
    }
  
    /*
    if (resto > 0) {
      letras += '';
    }

    return letras;
    */
    // ==
    /*
    console.log( 'num: ' + num );
    console.log( 'divisor: ' + divisor );
    let cientos = Math.floor(num / divisor);
    let resto = num - (cientos * divisor);
    console.log( 'cientos: ' + cientos );
    console.log( 'resto: ' + resto );

    let letras = '';

    if (cientos > 0) {
      if (cientos > 1) {
        // letras = this.centenas(cientos) + ' ' + strPlural;
        letras = cientos + ' ' + strPlural + this.centenas(cientos);
        console.log( letras );
      } else {
        letras = strSingular;
      }
    }

    if (resto > 0) {
      letras += '';
    }

    return letras;
    */
  } // Seccion()

  miles(pago) {

    console.log( pago );

    let divisor = 1000;
    let cientos = Math.floor(pago / divisor);
    let resto = pago - (cientos * divisor);

    console.log( 'cientos: ' + cientos );
    console.log( 'resto: ' + resto );

    let strMiles = this.seccion(pago, divisor, 'un millón', 'mil');
    // let strMiles = this.seccion(pago, divisor, 'un mil', 'mil');
    let strCentenas = this.centenas(resto);

    /*
    if (strMiles == '') {
      return strCentenas;
    }
    */
    
    return strMiles + ' ' + strCentenas;
    // return this.letra = '';

  } // Miles()

  millones(pago) {
    let divisor = 1000000;
    let cientos = Math.floor(pago / divisor);
    let resto = pago - (cientos * divisor);

    let strMillones = this.seccion(pago, divisor, 'un millón de', 'millones de');
    console.log( strMillones );
    let strMiles = this.miles(resto);
    console.log( strMiles );

    /*
    if (strMillones == '') {
      return strMiles;
    }
    return strMillones + ' ' + strMiles;
    */
  } // Millones()

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/formatos/solicitud-transferencias/solicitud-transferencias.component.ts